import React, { Fragment, useEffect, useState } from 'react';
import { Input, Button, Spinner } from "@material-tailwind/react";
import { Dialog, Transition } from '@headlessui/react';

export default function UploadAuth({ open, uploadId, authenticatePassword }) {
  const [isOpen, setIsOpen] = useState(open);
  const [password, setpassword] = useState("");
  const [message, setMessage] = useState("");
  const [state, setState] = useState("idle"); // authenticatin, error, success, idle

  useEffect(() => {
    setIsOpen(open);
  }, [open])

  async function handleSubmitPassword() {
    setState("authenticating")
    const result = await authenticatePassword(password);
    if (result !== true) {
      setMessage(result);
      setState("error");
    } else {
      setMessage("Success")
      setState("success");
    }
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-2xl mb-4 font-semibold leading-6 text-gray-900"
                >
                  <span>Password Required!</span>
                </Dialog.Title>
                <div className='mb-2'>
                  <span className={`${state === "success" ? "text-green-500" : "text-red-500"} font-bold`}>{message}</span>
                  <Input 
                    onChange={(e) => setpassword(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" ? handleSubmitPassword() : ""}
                    value={password} 
                    type="password" 
                    label='Password' 
                    error={state === "error"}
                    success={state === "success"}
                  />
                  <span className='font-light text-gray-500 text-sm'>A password is required to view this upload.</span>
                </div>

                <div className='w-full flex justify-end'>
                  <Button onClick={handleSubmitPassword} color={state === "success" ? "green" : "red"}>
                    <span className={state === "authenticating" ? "hidden" : ""}>Submit</span>
                    <span className={state === "authenticating" ? "" : "hidden"}><Spinner className='h-4 w-4' /></span>
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
